import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { FiGrid, FiMessageSquare, FiEdit3, FiBarChart2, FiSettings, FiLogOut, FiSun, FiMoon, FiHome } from 'react-icons/fi';

const AdminLayout = () => {
  const { logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/drnileshpanchal/login');
  };

  const logoSrc = theme === 'dark' ? '/whitelogo.png' : '/logo.png';

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <img
            src={logoSrc}
            alt="Dr. Nilesh Panchal"
            style={{
              height: '42px',
              width: 'auto',
              objectFit: 'contain',
              display: 'block',
              marginBottom: '6px',
            }}
          />
          <p>Admin Panel</p>
        </div>

        <ul className="admin-nav">
          <li>
            <NavLink to="/drnileshpanchal" end className={({ isActive }) => isActive ? 'active' : ''}>
              <FiGrid size={18} /> Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink to="/drnileshpanchal/messages" className={({ isActive }) => isActive ? 'active' : ''}>
              <FiMessageSquare size={18} /> Messages
            </NavLink>
          </li>
          <li>
            <NavLink to="/drnileshpanchal/content" className={({ isActive }) => isActive ? 'active' : ''}>
              <FiEdit3 size={18} /> Edit Content
            </NavLink>
          </li>
          <li>
            <NavLink to="/drnileshpanchal/analytics" className={({ isActive }) => isActive ? 'active' : ''}>
              <FiBarChart2 size={18} /> Analytics
            </NavLink>
          </li>
          <li>
            <NavLink to="/drnileshpanchal/settings" className={({ isActive }) => isActive ? 'active' : ''}>
              <FiSettings size={18} /> Settings
            </NavLink>
          </li>
          <li style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid var(--border-color)' }}>
            <a href="/" target="_blank" rel="noopener noreferrer">
              <FiHome size={18} /> View Site
            </a>
          </li>
          <li>
            <button onClick={toggleTheme}>
              {theme === 'dark' ? <><FiSun size={18} /> Light Mode</> : <><FiMoon size={18} /> Dark Mode</>}
            </button>
          </li>
          <li>
            <button onClick={handleLogout} style={{ color: 'var(--error)' }}>
              <FiLogOut size={18} /> Logout
            </button>
          </li>
        </ul>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;